export const INVITE_PROMPT_ON_LINK_INSERT_V2 = 'invite_prompt_on_link_insert_v2';

export type InvitePromptOnLinkFeatureFlag = typeof INVITE_PROMPT_ON_LINK_INSERT_V2;

export const SOURCE = {
	ISSUE_VIEW: 'issue-view',
	CREATE_ISSUE: 'create-issue',
	CREATE_LINK: 'create-link',
} as const;

export type Source = (typeof SOURCE)[keyof typeof SOURCE];
